import FollowModal from './components/FollowModal';

export default FollowModal